import React from 'react';
import {
  FaReact,
  FaNodeJs,
  FaPython,
  FaDocker,
  FaGitAlt,
  FaAws,
  FaHtml5,
  FaCss3Alt,
  FaJs,
} from 'react-icons/fa';
import {
  SiNextdotjs,
  SiTypescript,
  SiTailwindcss,
  SiRedux,
  SiSupabase,
  SiFirebase,
  SiMongodb,
  SiMysql,
  SiNestjs,
  SiRabbitmq,
} from 'react-icons/si';
import {
  Main,
  MaxWidth,
  Title,
  Heading,
  Group,
  GroupTitle,
  Grid,
  Card,
} from './Skills.elements';

const SKILLS = [
  {
    group: 'Frontend',
    items: [
      { name: 'React', icon: FaReact, brand: '#61DAFB' },
      { name: 'React Native', icon: FaReact, brand: '#61DAFB' },
      { name: 'Next.js', icon: SiNextdotjs, brand: '#ffffff' },
      { name: 'TypeScript', icon: SiTypescript, brand: '#3178C6' },
      { name: 'JavaScript', icon: FaJs, brand: '#F7DF1E' },
      { name: 'HTML5', icon: FaHtml5, brand: '#E34F26' },
      { name: 'CSS3', icon: FaCss3Alt, brand: '#1572B6' },
      { name: 'Redux', icon: SiRedux, brand: '#764ABC' },
      { name: 'Tailwind CSS', icon: SiTailwindcss, brand: '#38BDF8' },
    ],
  },
  {
    group: 'Backend',
    items: [
      { name: 'Node.js', icon: FaNodeJs, brand: '#539E43' },
      { name: 'Nest.js', icon: SiNestjs, brand: '#E0234E' },
      { name: 'Python', icon: FaPython, brand: '#3776AB' },
      { name: 'RabbitMQ', icon: SiRabbitmq, brand: '#FF6600' },
    ],
  },
  {
    group: 'Databases',
    items: [
      { name: 'Supabase', icon: SiSupabase, brand: '#3FCF8E' },
      { name: 'Firebase', icon: SiFirebase, brand: '#FFCA28' },
      { name: 'MongoDB', icon: SiMongodb, brand: '#47A248' },
      { name: 'MySQL', icon: SiMysql, brand: '#4479A1' },
    ],
  },
  {
    group: 'DevOps & Tools',
    items: [
      { name: 'Docker', icon: FaDocker, brand: '#2496ED' },
      { name: 'Git', icon: FaGitAlt, brand: '#F05032' },
      { name: 'AWS', icon: FaAws, brand: '#FF9900' },
    ],
  },
];

const reveal = {
  hidden: { opacity: 0, y: 22 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.45, delay: 0.04 * i, ease: 'easeOut' },
  }),
};

function Skills() {
  return (
    <Main id="skills">
      <MaxWidth>
        <Title variants={reveal} initial="hidden" animate="visible">
          What I work with
        </Title>
        <Heading variants={reveal} custom={1} initial="hidden" animate="visible">
          My Skills
        </Heading>

        {SKILLS.map((cat, gi) => (
          <Group key={cat.group}>
            <GroupTitle
              variants={reveal}
              custom={gi}
              initial="hidden"
              animate="visible"
            >
              {cat.group}
            </GroupTitle>
            <Grid>
              {cat.items.map((s, i) => {
                const Icon = s.icon;
                return (
                  <Card
                    key={s.name}
                    $brand={s.brand}
                    variants={reveal}
                    custom={i + 1}
                    initial="hidden"
                    animate="visible"
                  >
                    <Icon />
                    <span>{s.name}</span>
                  </Card>
                );
              })}
            </Grid>
          </Group>
        ))}
      </MaxWidth>
    </Main>
  );
}

export default Skills;
